import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { TranslationProvider, useTranslation } from '@ibk/shared-translation';
import { Icon } from '@ibk/shared-ui';
import { beneficiosTranslations } from '../../translations';
import styles from './RechargePaymentBenefits.module.css';
function RechargePaymentBenefitsContent() {
    const { t } = useTranslation();
    const benefitsTranslationPrefix = 'benefits.recharge.payment.benefits';
    const benefits = [
        {
            key: 'validityTime',
            iconName: 'rechargeClockGray',
            translationKey: `${benefitsTranslationPrefix}.validityTime`,
        },
        {
            key: 'registeredProcessed',
            iconName: 'rechargeTransactionGray',
            translationKey: `${benefitsTranslationPrefix}.registeredProcessed`,
        },
        {
            key: 'noExtraCharges',
            iconName: 'rechargePaymentGray',
            translationKey: `${benefitsTranslationPrefix}.noExtraCharges`,
        },
        {
            key: 'noWhatsappCodes',
            iconName: 'rechargeKeyGray',
            translationKey: `${benefitsTranslationPrefix}.noWhatsappCodes`,
        },
        {
            key: 'noDataSharing',
            iconName: 'rechargeSecurityGray',
            translationKey: `${benefitsTranslationPrefix}.noDataSharing`,
        },
    ];
    return (_jsx("div", { className: `${styles.benefits}`, "data-testid": 'viewRechargePaymentBenefitsContainer', children: benefits.map((benefit, index) => (_jsxs("div", { className: styles.benefitItem, "data-testid": `viewRechargePaymentBenefitsItem${index}`, children: [_jsx(Icon, { name: benefit.iconName, className: styles.icon, "data-testid": `iconRechargePaymentBenefitsItem${index}` }), _jsx("p", { className: styles.text, "data-testid": `textViewRechargePaymentBenefitsItem${index}`, dangerouslySetInnerHTML: { __html: t(benefit.translationKey) } })] }, benefit.key))) }));
}
export const RechargePaymentBenefits = () => {
    return (_jsx(TranslationProvider, { translations: beneficiosTranslations, children: _jsx(RechargePaymentBenefitsContent, {}) }));
};
